/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Consent_ChangedInputs */

const en_us2_body_assessment_consent_changed = /** @type {(inputs: Body_Assessment_Consent_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This text has changed since you agreed. Read it again to carry on using photos.`)
};

const pt_br2_body_assessment_consent_changed = /** @type {(inputs: Body_Assessment_Consent_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este texto mudou desde que você concordou. Leia de novo para continuar usando as fotos.`)
};

const es_419_body_assessment_consent_changed = /** @type {(inputs: Body_Assessment_Consent_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este texto cambió desde que aceptaste. Vuelve a leerlo para seguir usando fotos.`)
};

const pt_pt2_body_assessment_consent_changed = /** @type {(inputs: Body_Assessment_Consent_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este texto mudou desde que concordaste. Lê-o de novo para continuares a usar as fotos.`)
};

const fr_fr2_body_assessment_consent_changed = /** @type {(inputs: Body_Assessment_Consent_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce texte a changé depuis ton accord. Relis-le pour continuer à utiliser les photos.`)
};

const de_de2_body_assessment_consent_changed = /** @type {(inputs: Body_Assessment_Consent_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Text hat sich seit deiner Zustimmung geändert. Lies ihn erneut, um weiter Fotos zu nutzen.`)
};

const it_it2_body_assessment_consent_changed = /** @type {(inputs: Body_Assessment_Consent_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo testo è cambiato da quando hai accettato. Rileggilo per continuare a usare le foto.`)
};

/**
* | output |
* | --- |
* | "This text has changed since you agreed. Read it again to carry on using photos." |
*
* @param {Body_Assessment_Consent_ChangedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_consent_changed = /** @type {((inputs?: Body_Assessment_Consent_ChangedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Consent_ChangedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_consent_changed(inputs)
	if (locale === "es-419") return es_419_body_assessment_consent_changed(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_consent_changed(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_consent_changed(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_consent_changed(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_consent_changed(inputs)
	return en_us2_body_assessment_consent_changed(inputs)
});
export { body_assessment_consent_changed as "body-assessment.consent_changed" }